module.exports = __webpack_public_path__ + "static/media/put-forward.11225643.svg";